import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createProject, incrementCount } from '../../store/actions/projectActions'
import { Redirect } from 'react-router-dom'
import firebase from "firebase";
import VerifyEmail from '../layout/VerifyEmail';
import CreateModal from './CreateModal';
// import moment from 'moment';
import M from 'materialize-css';
M.AutoInit();
class CreateProject extends Component {


	state = {
		fileSizeOK: null,
		title: '',
		content: '',
		email1: this.props.auth.email,
		email2: '',
		sign1: false,
		filename: '',
		clicked: false,
		// username: "",
		// avatar: "",
		// isUploading: false,
		// progress: 0,
		// avatarURL: "",
		docType: 'uploaded',
		finalized: false,
		isModalShown: false
	}


	handleChange = (e) => {
		if (e.target.id === "sign1") {
			this.setState({
				[e.target.id]: e.target.checked
			})
		} else if (e.target.id === "content" && e.target.files[0]) {
			if (e.target.files[0].size < 2000000) {
				this.setState({
					fileSizeOK: true,
					filename: e.target.files[0],
					content: e.target.files[0]
				})
			} else {
				this.setState({
					fileSizeOK: false
				})
			}
		} else {
			this.setState({
				[e.target.id]: e.target.value
			})
		}

	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.setState({ clicked: true })
		const nda = this.state.filename;
		const ndaName = Math.floor(Date.now() / 1000) + "_" + Math.round(Math.random() * 1000000) + '.pdf'
		const fileUploadTask = firebase
			.storage()
			.ref(`ndas/${ndaName}`)
			.put(nda);

		fileUploadTask.on('state_changed',
			(snapshot) => {

			},
			(error) => {
				console.log(error)
			},
			() => {
				firebase
					.storage()
					.ref("ndas")
					.child(ndaName)
					.getDownloadURL()
					.then(url => {
						// const fname = url.split("?")[0]
						this.props.createProject({
							...this.state,
							sign2: false,
							signedAt: null,
							filename: url,
							content: url,
							ndaName: ndaName
						})
					})
					.then(
						this.props.incrementCount()
					)
					// .then(
					// 	M.toast({ html: `You created and signed ${nda.name}! \nLink sent to ${this.state.email2}`, classes: 'rounded', displayLength: 8000 })
					// )
					.then(this.setState({ isModalShown: true }))

			}
		)
	}
	render() {

		const { auth, profile } = this.props
		const fullname = profile.firstName + " " + profile.lastName
		if (!auth.uid) {
			return <Redirect to={'/signin'} />
		} else if (auth.uid && !profile.esign && profile.isLoaded) {
			return <Redirect to={'/mysign'} />
		}

		if ((profile.createCount > 3) && ((profile.plan === null) || (!('plan' in profile)))) {
			return <Redirect to={'/upgrade'} />
		} else if (profile.createCount > 10 && (parseInt(profile.plan, 10) !== 2)) {
			return <Redirect to={'/upgrade'} />
		}

		if (auth.emailVerified) {
			return (
				<div className="grey lighten-5">
					<div className="container">
						<div className="row"></div>
						<form onSubmit={this.handleSubmit} className="white">
							<h5 className="grey-text text-darken-3">Create New NDA</h5>

							<div className="input-field">
								<label className="active" htmlFor="title">Title</label>
								<input type="text" id="title" onChange={this.handleChange} />
							</div>

							<div className="file-field input-field">
								<label className="active" htmlFor="content">Click to upload NDA (pdf upto 2MB only)</label>
								<input id="content" type="file" accept="application/pdf" onChange={this.handleChange} />
								<div className="file-path-wrapper">
									<input className="file-path validate" type="text" />
								</div>
							</div>
							<div className="red-text center">
								{this.state.fileSizeOK === false ? <p>Max size 2MB</p> : null}
							</div>

							<div className="input-field">
								<label className="active" htmlFor="email">Send to</label>
								<input type="email" id="email2" onChange={this.handleChange} />
							</div>

							<div className="input-field">
								<label className="active" htmlFor="name1" class="active">Your Name</label>
								<input value={fullname} type="text" id="name1" disabled />
							</div>
							<div className="input-field">
								<label className="active" htmlFor="email" class="active">Send from</label>
								<input value={auth.email} type="email" id="email1" disabled />
							</div>

							<div className="input-field">
								<p>
									<label htmlFor="sign1">
										<input type="checkbox" id="sign1" onChange={this.handleChange} />
										<span>Sign</span>
									</label>
								</p>
							</div>
							{this.state.clicked ? (<div className="preloader-wrapper big active">
								<div className="spinner-layer spinner-teal-only">
									<div className="circle-clipper left">
										<div className="circle"></div>
									</div><div className="gap-patch">
										<div className="circle"></div>
									</div><div className="circle-clipper right">
										<div className="circle"></div>
									</div>
								</div>
							</div>) : (
									<div className="input-field">
										<button className="btn teal lighten-1 z-depth-0" disabled={this.state.title === "" || this.state.content === "" || this.state.email2 === "" || this.state.sign1 === false}>CREATE</button>
									</div>)}
						</form>
						<div className="row"></div>
						<div className="row"></div>
						<div className="row"></div>
						<div className="row"></div>
						<div className="row"></div>
						<div className="row"></div>
					</div>

					{this.state.isModalShown &&
						<CreateModal onClose={() => {
							this.setState({
								isModalShown: false
							})
							this.props.history.push('/dashboard')
						}} />
					}

				</div>
			)
		} else if (auth && !auth.emailVerified) {
			return (
				<VerifyEmail auth={auth} />
			)
		}
	}
}

const mapStateToProps = (state) => {
	return {
		auth: state.firebase.auth,
		profile: state.firebase.profile
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		createProject: (project) => dispatch(createProject(project)),
		incrementCount: () => dispatch(incrementCount())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProject);